module.exports = __webpack_public_path__ + "img/cc_tooltip.6aba4290.svg";